import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 28,
  medium: 20,
  small: 15,
  xSmall: 12
};
const LinkedInFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 5C6.79086 5 5 6.79086 5 9V21C5 23.2091 6.79086 25 9 25H21C23.2091 25 25 23.2091 25 21V9C25 6.79086 23.2091 5 21 5H9ZM10 10.1548C10 10.7926 10.5157 11.31 11.1556 11.31C11.7926 11.31 12.31 10.7926 12.31 10.1548C12.31 9.51739 11.7926 9 11.1556 9C10.5157 9 10 9.51739 10 10.1548ZM18.1726 19.395H20.395V15.6865C20.395 13.8652 19.9792 12.465 17.7286 12.465C16.6474 12.465 15.9225 13.0256 15.6261 13.5574H15.5956V12.6329H13.465V19.395H15.6851V16.0505C15.6851 15.1684 15.8616 14.3138 17.0178 14.3138C18.1585 14.3138 18.1726 15.3225 18.1726 16.1067V19.395ZM12.31 19.395H10V12.465H12.31V19.395Z",
        fill: "currentColor"
      }
    )
  );
};
LinkedInFilledIcon.iconName = "LinkedInFilledIcon";

export { LinkedInFilledIcon };
